import axios from 'axios'

export default ({ app }, inject) => {
  // Create axios instance with default config
  const axiosInstance = axios.create({
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    withCredentials: false,
  })

  const dashboardApi = {
    /**
     * Submit contact form data to dashboard API
     * @param {Object} formData - The form data to submit
     * @returns {Promise<Object>} API response
     */
    async submitContact(formData) {
      try {
        const apiUrl = process.env.DASHBOARD_API_URL

        if (!apiUrl) {
          console.error('DASHBOARD_API_URL not configured in environment')
          throw new Error('Dashboard API URL not configured')
        }

        const payload = {
          ...formData,
          locale: app.i18n.locale,
        }

        const endpoint = `${apiUrl}/leads/process`

        const response = await axiosInstance.post(endpoint, payload)

        console.log('Dashboard API Response:', response.data)
        return response.data
      } catch (error) {
        console.error('Dashboard API Error:', {
          message: error.message,
          response: error.response?.data,
          status: error.response?.status,
        })

        // Re-throw error para ser tratado pelo componente
        throw error
      }
    },
  }

  // Inject $dashboardApi to make it available globally
  inject('dashboardApi', dashboardApi)
}
